<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <GroupForm @submit-requested="submitRequested"></GroupForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import GroupForm from './GroupForm.vue'

  export default {
  components: { GroupForm },
  methods: {
    ...mapActions('groups', ['postGroup']),
    submitRequested (input) {
      this.postGroup(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 